import BaseApi from '../base';

class StrategyApi extends BaseApi {
  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getStrategies(token) {
    return await this.makeRequest(this.METHOD_GET, '', token);
  }

  /**
   * @param {string} token
   * @param {string} user
   * @returns {Promise<*>}
   */
  async getStages(token, user) {
    return await this.makeRequest(this.METHOD_GET, `stages?user=${user}`, token);
  }

  /**
   * @param {string} token
   * @param data
   * @returns {Promise<*>}
   */
  async addStage(token, data) {
    return this.makeRequest(this.METHOD_POST, 'stages', token, data);
  }

  /**
   * @param {string} token
   * @param {string} id
   * @param data
   * @returns {Promise<*>}
   */
  async updateStage(token, id, data) {
    return this.makeRequest(this.METHOD_POST, `stages/${id}`, token, data);
  }

  /**
   * @param {string} token
   * @param {string} id
   * @param {string} strategyStage
   * @param {string} status
   * @returns {Promise<*>}
   */
  async changeGoalStatus(token, id, strategyStage, status) {
    return this.makeRequest(this.METHOD_POST, `goals/${id}`, token, {status, strategyStage});
  }
}

export default StrategyApi;
